// src/pages/Accessori/Accessories.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useOrder } from '../../context/OrderContext';
import { Header } from '../../layout';

const AccessoryOption = ({ title, icon, onClick }) => (
  <button
    onClick={onClick}
    className="p-4 border-2 rounded-xl transition-all border-gray-200 bg-white hover:border-red-500 hover:shadow-lg"
  >
    <div className="flex flex-col items-center">
      <div className="w-full h-20 mb-2 flex items-center justify-center">
        <img src={icon} alt={title} className="h-16 object-contain" />
      </div>
      <span className="font-medium text-gray-700">{title}</span>
    </div>
  </button>
);

const Accessories = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, dispatch } = useOrder();
  const [selectedAccessories, setSelectedAccessories] = useState([]);

  // Get context from navigation state or order details
  const fromProfileConfiguration = location.state?.fromProfileConfiguration;
  const rawProfileType = location.state?.profileType || state.orderDetails.profileType || state.orderDetails.ninfaNumber;

  // Normalize profile type to ensure it has the "N" prefix (only if profileType exists)
  const profileType = rawProfileType ? (rawProfileType.startsWith('N') ? rawProfileType : `N${rawProfileType}`) : null;

  const accessories = [
    { id: 'giunzioni', title: 'Giunzioni', icon: '/images/accessories/GENERALE/SEL-GIUNZIONI.png' },
    { id: 'corrimano', title: 'Corrimano', icon: '/images/accessories/GENERALE/SEL-CORRIMANO.png' },
    { id: 'coprifilo', title: 'Coprifilo', icon: '/images/accessories/GENERALE/SEL-COPRIFILO.png' },
    { id: 'led', title: 'LED', icon: '/images/accessories/GENERALE/SEL-LED.png' },
    { id: 'tappi', title: 'Tappi NINFA', icon: '/images/accessories/GENERALE/SEL-TAPPI.png' },
    { id: 'spessori', title: 'Spessori', icon: '/images/accessories/GENERALE/SEL-SPESSORI.png' }
  ];

  const toggleAccessory = (accessoryId) => {
    setSelectedAccessories(prev => {
      if (prev.includes(accessoryId)) {
        return prev.filter(id => id !== accessoryId);
      }
      return [...prev, accessoryId];
    });
  };

  const handleAccessoryClick = (accessoryId) => {
    // Navigate to the accessories process page with the selected accessory type
    navigate(`/accessories-process/${accessoryId}`, {
      state: {
        fromProfileConfiguration: fromProfileConfiguration,
        profileType: profileType
      }
    });
  };

  const handleConfirm = () => {
    dispatch({
      type: 'UPDATE_ORDER',
      payload: { accessories: selectedAccessories }
    });
    navigate('/order-details');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Header title="Seleziona Accessori" />

      <div className="container mx-auto px-4 py-8">
        <div className="text-center">
          {/* Profile context info */}
          {fromProfileConfiguration && profileType && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
              <h3 className="font-medium text-red-900 mb-2">Accessori per il tuo profilo</h3>
              <p className="text-sm text-red-800">
                Stai configurando accessori compatibili con il profilo <strong>{profileType}</strong>.
                <br />
                Seleziona gli accessori che desideri aggiungere al tuo ordine.
              </p>
            </div>
          )}

          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
            {accessories.map((accessory) => (
              <AccessoryOption
                key={accessory.id}
                id={accessory.id}
                title={accessory.title}
                icon={accessory.icon}
                onClick={() => handleAccessoryClick(accessory.id)}
              />
            ))}
          </div>

          <div className="mt-6 flex justify-center space-x-4">
            <button
              onClick={() => {
                if (fromProfileConfiguration) {
                  // If coming from profile configuration, go to cart
                  navigate('/order-summary');
                } else {
                  // Otherwise, go back
                  navigate(-1);
                }
              }}
              className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
            >
              {fromProfileConfiguration ? 'Vai al Carrello' : 'Indietro'}
            </button>

            {fromProfileConfiguration && (
              <button
                onClick={() => navigate('/product-categories')}
                className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
              >
                Aggiungi Altri Prodotti
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accessories;
